var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cjqdoa0uea",
    d: "M0 0.877L23.4 0.877 23.4 24.3 0 24.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M18.45 10.696c0 4.81-3.896 8.709-8.7 8.709-4.805 0-8.7-3.9-8.7-8.709 0-4.81 3.895-8.708 8.7-8.708 4.804 0 8.7 3.899 8.7 8.708"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "njn27qedlb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cjqdoa0uea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M23.115 21.947l-5.52-5.53c1.193-1.62 1.905-3.615 1.905-5.78 0-5.39-4.364-9.76-9.75-9.76C4.365.877 0 5.247 0 10.637s4.365 9.759 9.75 9.759c2.165 0 4.158-.714 5.776-1.91l5.523 5.529c.38.38 1 .38 1.38 0l.687-.69c.379-.378.379-1-.001-1.378zM9.75 4.78c1.346 0 2.437 1.093 2.437 2.44 0 1.348-1.09 2.44-2.437 2.44-1.346 0-2.437-1.092-2.437-2.44 0-1.347 1.09-2.44 2.437-2.44zM15.6 15.79c-1.428 1.625-3.517 2.655-5.85 2.655-2.333 0-4.42-1.03-5.85-2.656V14.54c0-1.61 1.317-2.926 2.925-2.926h5.85c1.61 0 2.925 1.315 2.925 2.926v1.25z",
    mask: "url(#njn27qedlb)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanResources);
export default __webpack_public_path__ + "static/media/humanResources.ff08b42733ed9d3fb0320f3b6ce2e672.svg";
export { ForwardRef as ReactComponent };